export default "__VITE_ASSET__5b7296c0__"